module.exports = __webpack_public_path__ + "static/img/cp_icon_B08.851dc76.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/cp_icon_B08.png
// module id = pe1D
// module chunks = 1